import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withAuthorization } from '../Session';

class RefferStore extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        alertMessage: '',
        flag: false,
        FullName: '',
        EmailId: '',
        PhoneNumber: '',
        City: '',
        State: '',
        AllStates: [
            'Andhra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Andaman and Nicobar Islands',
            'Bihar',
            'Chandigarh',
            'Chhattisgarh',
            'Delhi',
            'Dadra and Nagar Haveli and Daman and Diu',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu and Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Ladakh',
            'Lakshadweep',
            'Madhya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Odisha',
            'Punjab',
            'Puducherry',
            'Rajasthan',
            'Sikkim',
            'Tamil Nadu',
            'Telangana',
            'Tripura',
            'Uttar Pradesh',
            'Uttarakhand',
            'West Bengal'
        ]
    };

    async componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    editProfileData = () => {
        let today_Date = new Date();
        let DateOfReferral =
            today_Date.getFullYear() +
            '-' +
            String(parseInt(today_Date.getMonth()) + 1).padStart(2, '0') +
            '-' +
            String(today_Date.getDate()).padStart(2, '0') +
            ' ' +
            today_Date.getMonth() +
            ':' +
            today_Date.getMinutes() +
            ':' +
            today_Date.getSeconds();
        let data = {
            Name: this.state.FullName,
            MobileNumber: '+91'+this.state.PhoneNumber.substring(this.state.PhoneNumber.length - 10),
            City: this.state.City,
            State: this.state.State,
            DateOfReferral: DateOfReferral,
            ReferralName: this.props.user.FullName,
            ReferralPhoneNumber: this.props.user.PhoneNumber,
            UniqeID: this.props.user.ProfileUniqeID
        };

        var validationResult = this.validateForm();

        if (validationResult.isError) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: validationResult.errorMsg
                });
            }
        } else {
            if (this._isMounted) {
                this.setState({ flag: true, alert: 0, alertMessage: '' });
            }
            
            RestServices.addNewRefferal(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (responseData.status) {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 2,
                                    alertMessage: responseData.message
                                });
                            }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 1,
                                    alertMessage: responseData.error
                                });
                            }
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        }
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <Row>
                    <Col>
                        <h5>Refer & Earn</h5>
                        <p>
                            For every successful referral done through you, you
                            will get paid 25% of the referral fee collected.
                        </p>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="FullName"
                            value={this.state.FullName}
                            onChange={this.onChangeValues}
                            required
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="PhoneNumber"
                            value={this.state.PhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>

                        <Autocomplete
                            name="State"
                            value={this.state.State}
                            onChange={(event, newValue) => {
                                this.setState({ State: newValue });
                            }}
                            id="user_State"
                            options={this.state.AllStates.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>
                <hr />
                <Form.Row>
                    <Button
                        variant="primary"
                        type="submit"
                        onClick={this.editProfileData}
                    >
                        Submit
                    </Button>
                </Form.Row>

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                <Row>
                    <Col>
                        <hr />
                        <p>
                            For example, if your referral makes a payment of
                            10,000 Rs, you will get a referral bonus of 2,500.
                        </p>
                        <hr />
                    </Col>
                </Row>
            </Container>
        );
    }

    validateForm = () => {
        let isError = false;
        let errorMsg = '';

        if (this.state.FullName == '') {
            isError = true;
            errorMsg = errorMsg + ' Please enter name.';
        }

        if (this.state.City == '') {
            isError = true;
            errorMsg = errorMsg + ' Please enter City.';
        }

        if (this.state.State == '') {
            isError = true;
            errorMsg = errorMsg + ' Please select State.';
        }

        let PhoneNumber = this.state.PhoneNumber.replace('+91', '');

        if (PhoneNumber.length != 10 || !PhoneNumber.match('[0-9]{10}')) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid  Phone Number.';
        }

        var reurndata = [];
        reurndata.isError = isError;
        reurndata.errorMsg = errorMsg;
        return reurndata;
    };
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(RefferStore);
